import { onLogin } from '../me/login-event';
import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { $date, $time } from '../y/time';
import { PCode, PCodeKind, PPromo } from './p-promo';

export function pCodesByKind(kind: PCodeKind) {
    return $api.GET<PCode[]>(`p/codes/by_kind/${kind}`);
}

export function pCodesCreate(value: any) {
    return $api.POST<PCode[]>('p/codes', value);
}

export function pCodeDelete(code: string) {
    return $api.DELETE(`p/code/${code}`);
}

export function pCodeIsUsable(code: PCode) {
    const expires = $time(code.expires_at);

    return !(expires?.is_past || (code.usage_max && code.usage_count >= code.usage_max));
}

export function pPromoDiscountDescription(p: PPromo) {
    if(p.kind == 'signup' || p.kind == 'resubscribe') {
        for(const e of p.effect) {
            if(e.kind == 'subscription') {
                return e.duration_months + ' months for ' + (e.subscription_price.standard?.SEK || 0) / 100 + ' / ' + (e.subscription_price.plusone?.SEK || 0) / 100 + ' SEK';
            } else if(e.kind == 'subscription_discount') {
                let text = (290 + (e.subscription_discount.standard?.SEK || 0) / 100) + ' / ' + (550 + (e.subscription_discount.plusone?.SEK || 0) / 100);
                const until = $date(e.subscription_discount_end);
                if(until)
                    text += ' until ' + until.format('dd/MM/yyyy');
                else if(e.duration_months == 1)
                    text += ' first month';
                else if(e.duration_months)
                    text += ' for ' + e.duration_months + ' months';
                return text;
            }
        }

        return '';
    } else if(p.kind == 'giftcard' || p.kind == 'ppv') {
        for(const e of p.effect) {
            if(e.kind == 'purchase_discount') {
                let text = '';
                if(e.discount?.SEK)
                    text += (-e.discount.SEK / 100) + ' SEK';
                if(e.discount_percent) {
                    if(text.length)
                        text += ' + ';
                    text += (-e.discount_percent) + '%';
                }

                if(text) {
                    return text + ' discount';
                }
            }
        }
    }

    return '-';
}

export const p_promos = makeDataStore('promos', 'promo', (m: PPromo) => m, Object.assign);

onLogin(data => {
    if(data.promos)
        p_promos.init(data.promos);
});
